// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/kiosk/GenericUIButton/generic-ui-button.scss
// module id = 49
// module chunks = 0